import React, { useRef, useEffect } from 'react';
import mapboxgl from 'mapbox-gl';
import MultiTouch from 'mapbox-gl-multitouch';

mapboxgl.accessToken = process.env.REACT_APP_MAPBOX_ACCESS_TOKEN;

const mapMarker = () => new mapboxgl.Marker();

const MapboxMap = ({
  location = null,
  zoom = 5,
  containerClassName = '',
  mapClassName = 'map-container',
  city,
}) => {
  const mapContainer = useRef(null);
  const map = useRef(null);
  const centerMarker = useRef(null);

  useEffect(() => {
    const center = location || { lat: 40.4168, lng: -3.7038 };
    const position = [center.lng, center.lat];

    map.current = new mapboxgl.Map({
      container: mapContainer.current,
      style: 'mapbox://styles/mapbox/streets-v10',
      center: position,
      zoom,
      scrollZoom: false,
    });

    map.current.addControl(new mapboxgl.NavigationControl({ showCompass: false }), 'top-left');
    map.current.addControl(new MultiTouch());

    centerMarker.current = mapMarker();
    centerMarker.current.setLngLat(position).addTo(map.current);

    return () => {
      if (map.current) {
        centerMarker.current = null;
        map.current.remove();
        map.current = null;
      }
    };
  }, []);

  useEffect(() => {
    if (!map.current || !centerMarker.current) return;

    const center = location || { lat: 40.4168, lng: -3.7038 };
    const position = [center.lng, center.lat];

    map.current.setZoom(zoom);
    centerMarker.current.setLngLat(position);
    map.current.setCenter(position);
  }, [location, zoom]);

  return (
    <div className={containerClassName}>
      <div className={mapClassName} ref={mapContainer} style={{ width: '100%', height: '500px' }} />
    </div>
  );
};

export default MapboxMap;
